import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { PhoneCall, Flame, Gift, ReceiptText, Mail, PackageCheck, Home, ArrowRight, Signal } from "lucide-react";

const SERVICES = [
  { to: "esim-simamma", ready: true, title: "SiMamma eSIM", desc: "eSIM internazionali: scegli la destinazione, paga con carta e trova il QR nei tuoi acquisti.", icon: Signal, color: "text-blue-500", bg: "bg-blue-500/10" },
  { to: "energia-cliente", ready: true, title: "Luce & Gas", desc: "Passa con noi per luce e gas: carichi la bolletta e ti proponiamo l'offerta migliore.", icon: Flame, color: "text-orange-500", bg: "bg-orange-500/10" },
  { to: "giftcard-cliente", ready: true, title: "Gift Card", desc: "Acquista buoni regalo dei brand più famosi, consegnati subito via email.", icon: Gift, color: "text-fuchsia-500", bg: "bg-fuchsia-500/10" },
  { to: "ricarica-cliente", ready: true, title: "Ricarica telefonica", desc: "Ricarica il tuo numero o quello di chi vuoi, in Italia e all'estero.", icon: PhoneCall, color: "text-teal-500", bg: "bg-teal-500/10" },
  { to: "bollettini-cliente", ready: true, title: "Bollettini / PagoPA", desc: "Paga un avviso pagoPA in modo semplice e sicuro.", icon: ReceiptText, color: "text-blue-500", bg: "bg-blue-500/10" },
  { to: "pec-cliente", ready: false, title: "PEC", desc: "Attiva una casella di posta elettronica certificata.", icon: Mail, color: "text-indigo-500", bg: "bg-indigo-500/10" },
  { to: "raccomandata-cliente", ready: false, title: "Raccomandata A/R", desc: "Invia una raccomandata con avviso di ricevimento senza andare in posta.", icon: PackageCheck, color: "text-amber-500", bg: "bg-amber-500/10" },
  { to: "valutazioni-cliente", ready: false, title: "Valutazione immobiliare", desc: "Scopri il valore al m² di un immobile.", icon: Home, color: "text-emerald-500", bg: "bg-emerald-500/10" },
];

export default function ServiziCliente() {
  const navigate = useNavigate();
  const open = (s) => { if (s.ready) navigate(`/app/${s.to}`); else toast("Presto disponibile", { description: `${s.title} sarà attivabile a breve.` }); };
  return (
    <div className="space-y-6" data-testid="servizi-cliente-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizi</p>
        <h1 className="font-head text-3xl sm:text-4xl font-bold tracking-tight mt-1">Cosa vuoi fare oggi?</h1>
        <p className="text-sm text-muted-foreground mt-1">Tutti i servizi in un unico posto: luce e gas, gift card, ricariche, bollettini e altro.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s) => (
          <Card
            key={s.to}
            onClick={() => open(s)}
            className={`group p-5 cursor-pointer transition-colors ${s.ready ? "glow-border hover:border-primary/60" : "opacity-70 hover:opacity-100"}`}
            data-testid={`servizio-card-${s.to}`}
          >
            <div className="flex items-start justify-between">
              <div className={`w-12 h-12 rounded-xl ${s.bg} ${s.color} flex items-center justify-center`}><s.icon className="w-6 h-6" /></div>
              {!s.ready && <span className="text-[10px] uppercase tracking-wider text-muted-foreground border border-border rounded-full px-2 py-0.5">presto</span>}
            </div>
            <h2 className="font-head text-lg font-semibold mt-4" data-testid={`servizio-title-${s.to}`}>{s.title}</h2>
            <p className="text-sm text-muted-foreground mt-1" data-testid={`servizio-description-${s.to}`}>{s.desc}</p>
            {s.ready && <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">Inizia <ArrowRight className="w-4 h-4" /></div>}
          </Card>
        ))}
      </div>
    </div>
  );
}
